
import { useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetAssociationHistoryQuery } from "../associationApi";
import CommonHistoryForm from "../../../../components/common/CommonHistoryGrid/CommonHistoryGrid";


const AssociationHistoryForm = () => {

    const { associationId } = useParams();

    const {
        data: historyData,
        isLoading: loading,
        isError: error,
    } = useGetAssociationHistoryQuery(associationId || skipToken);

    return (
        <CommonHistoryForm
            data={historyData}
            title="Association History"
            count={historyData?.length || 0}
            hasAddPermission={true}
            hasSortPermission={true}
        />
    );
};

export default AssociationHistoryForm;
